export default "__VITE_ASSET__d77ba675__"